/* ============================================================
   VOMAIRE Cart Drawer + Sticky ATC
   Works alongside Impulse theme.js
   ============================================================ */
(function () {
  'use strict';

  /* ---------- config injected by Liquid ---------- */
  var CFG = window.VOMAIRE_CFG || {};
  var BUNDLE = (CFG.bundle && CFG.bundle.length) ? CFG.bundle : [
    { qty: 2, off: 10 }, { qty: 3, off: 20 }, { qty: 4, off: 30 }
  ];
  var MONEY_FORMAT = CFG.moneyFormat || '${{amount}}';

  /* ---------- helpers ---------- */
  function money(cents) {
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/, s.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fetchJSON(url, opts) { return fetch(url, opts).then(function (r) { return r.json(); }); }

  /* ---------- bundle discount math ---------- */
  function discountFor(qty) {
    var off = 0, label = null, next = null;
    BUNDLE.forEach(function (t) { if (qty >= t.qty) { off = t.off; label = t.qty; } });
    for (var i = 0; i < BUNDLE.length; i++) { if (qty < BUNDLE[i].qty) { next = BUNDLE[i]; break; } }
    return { off: off, label: label, next: next };
  }
  var DEFAULT_MSGS = [
    "You\u2019re NEED away from NEXTOFF% off \u2014 don\u2019t leave that on the table",
    "Great choice! Add NEED more to unlock NEXTOFF% off \u2014 treat yourself, you deserve it",
    "Almost there! Just NEED more to unlock our biggest savings \u2014 NEXTOFF% off everything",
    "You\u2019ve unlocked our biggest discount \u2014 OFF% off your entire order"
  ];
  function nonEmpty(arr, fallback) {
    if (!arr || !arr.length) return fallback;
    return arr.map(function(v, i) { return (v && v.length) ? v : fallback[i]; });
  }

  function bundleProgressHTML(cart, compact) {
    var qty = cart.item_count;
    var disc = discountFor(qty);
    var tierLabels = nonEmpty(CFG.cartTierLabels, ['10% OFF','20% OFF','30% OFF']);
    var msgs = nonEmpty(CFG.cartMessages, DEFAULT_MSGS);
    var msg, tierIndex = -1;
    BUNDLE.forEach(function(t, i) { if (qty >= t.qty) tierIndex = i; });
    if (!disc.next) {
      msg = msgs[msgs.length - 1].replace('OFF', disc.off);
    } else {
      var need = disc.next.qty - qty;
      var mi = Math.max(0, Math.min(tierIndex + 1, msgs.length - 2));
      msg = msgs[mi].replace('NEED', need).replace('NEXTOFF', disc.next.off);
    }
    var DOT_MAX = 88; /* max % position so dots don't hit the right edge */
    var dots = BUNDLE.map(function(t, i) {
      var active = qty >= t.qty;
      var pos = ((i + 1) / BUNDLE.length) * DOT_MAX;
      return '<div class="bprog__dot" style="left:' + pos + '%">' +
        '<div class="bprog__dot-circle ' + (active ? 'active' : '') + '">' +
          (active ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><path d="M5 12l5 5L19 7"/></svg>' : '') +
        '</div>' +
        '<span class="bprog__dot-label">' + tierLabels[i] + '</span>' +
      '</div>';
    }).join('');
    var maxQty = BUNDLE[BUNDLE.length - 1].qty;
    var pct = Math.min(100, (qty / maxQty) * 100);
    return '<div class="bprog bprog--clean' + (compact ? ' bprog--mini' : '') + '">' +
      '<div class="bprog__msg">' + msg + '</div>' +
      '<div class="bprog__bar-wrap">' +
        '<div class="bprog__track"><div class="bprog__fill" style="width:' + pct + '%"></div></div>' +
        dots +
      '</div>' +
    '</div>';
  }

  /* ---------- reward bar: free delivery (halfway) + mystery gift (£150) ---------- */
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1.5" y="5" width="12" height="10" rx="1.4"/><path d="M13.5 8.5h4l3.5 3.5V15h-7.5z"/><circle cx="5.5" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/></svg>';
  var ICON_GIFT  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="9.5" width="19" height="4.2" rx="1"/><path d="M4.5 13.7v6.3a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-6.3"/><line x1="12" y1="9.5" x2="12" y2="21"/><path d="M12 9.5S11 3 8 3a2.5 2.5 0 0 0 0 6.5z"/><path d="M12 9.5S13 3 16 3a2.5 2.5 0 0 1 0 6.5z"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';

  function giftThresholdCents() {
    var vc = (window.VLR_CART && window.VLR_CART.gift) ? window.VLR_CART.gift : 0;
    if (vc > 0) return vc;
    var t = parseInt(CFG.giftThreshold, 10);
    return (isNaN(t) || t <= 0) ? 15000 : t;
  }
  function freeShipThresholdCents() {
    var vc = (window.VLR_CART && window.VLR_CART.free) ? window.VLR_CART.free : 0;
    return (vc > 0) ? vc : 2000;
  }

  function rewardBarHTML(cart) {
    var total = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
    var giftCents = giftThresholdCents();
    var freeCents = Math.min(freeShipThresholdCents(), giftCents);
    var freeUnlocked = total >= freeCents;
    var giftUnlocked = total >= giftCents;
    var remaining = Math.max(0, giftCents - total);
    var remainingFree = Math.max(0, freeCents - total);

    /* Twee echte drempels: gratis verzending op freeCents (£20), mystery gift op giftCents (£50). */
    var freePct = giftCents > 0 ? (freeCents / giftCents) * 100 : 50;
    var pct = giftCents > 0 ? Math.min(100, (total / giftCents) * 100) : 0;

    var shipLabel = CFG.rewardShipLabel || 'Free delivery';
    var giftLabel = CFG.rewardGiftLabel || 'Mystery gift';
    var giftWorth = CFG.rewardGiftWorth || '£50';

    var VC = window.VLR_CART || {};
    var msg;
    if (!freeUnlocked) {
      msg = (VC.msgFree || "You're [amount] away from FREE SHIPPING").replace('[amount]', '<b>' + money(remainingFree) + '</b>');
    } else if (!giftUnlocked) {
      msg = 'Free shipping unlocked! Add <b>' + money(remaining) + '</b> more for a ' + giftWorth + ' mystery gift';
    } else {
      msg = 'Both unlocked \u2014 free shipping <b>and</b> your ' + giftWorth + ' mystery gift are in the box.';
    }

    var sub = giftUnlocked
      ? (CFG.rewardSubUnlocked || "You won't know what it is until you open it. That's the point.")
      : (CFG.rewardSubProgress || 'A real product, not a voucher. One per order, added automatically.');

    return '<div class="vlr-ship' + (giftUnlocked ? ' is-complete' : '') + '">' +
      '<div class="vlr-ship__msg">' + msg + '</div>' +
      '<div class="vlr-ship__track">' +
        '<div class="vlr-ship__fill" style="width:' + pct + '%"></div>' +
        '<span class="vlr-ship__node vlr-ship__node--ship' + (freeUnlocked ? ' is-done' : '') + '" style="left:' + freePct + '%">' +
          '<span class="vlr-ship__ico">' + ICON_TRUCK + '</span>' +
          (freeUnlocked ? '<span class="vlr-ship__tick">' + ICON_CHECK + '</span>' : '') +
        '</span>' +
        '<span class="vlr-ship__node vlr-ship__node--gift' + (giftUnlocked ? ' is-done' : '') + '" style="left:100%">' +
          '<span class="vlr-ship__ico">' + ICON_GIFT + '</span>' +
          (giftUnlocked ? '<span class="vlr-ship__tick">' + ICON_CHECK + '</span>' : '') +
        '</span>' +
      '</div>' +
      '<div class="vlr-ship__legend">' +
        '<span class="vlr-ship__leg vlr-ship__leg--ship is-done">' + shipLabel + '</span>' +
        '<span class="vlr-ship__leg vlr-ship__leg--gift' + (giftUnlocked ? ' is-done' : '') + '">' +
          giftLabel + ' <em>worth ' + giftWorth + '</em>' +
        '</span>' +
      '</div>' +
      '<div class="vlr-ship__sub">' + sub + '</div>' +
    '</div>';
  }

  /* Backwards compatible alias */
  function shippingBarHTML(cart) { return rewardBarHTML(cart); }

  /* ---------- trust badges (under checkout) ---------- */
  var TRUST_ICONS = {
    shield: '<path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z"/><path d="M9 12l2 2 4-4"/>',
    heart: '<path d="M12 20s-7-4.6-9.2-9C1.3 8 3 5 6 5c2 0 3 1.2 4 2.5C11 6.2 12 5 14 5c3 0 4.7 3 3.2 6-2.2 4.4-9.2 9-9.2 9z" transform="translate(-1 0)"/>',
    chat: '<path d="M20 4H4a1 1 0 00-1 1v11a1 1 0 001 1h3v3l4-3h9a1 1 0 001-1V5a1 1 0 00-1-1z"/>',
    truck: '<path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.5"/><circle cx="17" cy="18" r="1.5"/>',
    star: '<path d="M12 3l2.6 5.3 5.9.9-4.2 4.1 1 5.8-5.3-2.8-5.3 2.8 1-5.8L3.5 9.2l5.9-.9z"/>',
    lock: '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/>',
    leaf: '<path d="M4 20C3 12 8 5 20 4c1 11-5 16-13 16-1.5 0-3-.4-3-.4z"/><path d="M9 15c3-3 6-4 9-4.5"/>'
  };
  function trustHTML() {
    var items = (CFG.trust && CFG.trust.length) ? CFG.trust : [
      { icon: 'shield', text: 'Try us risk-free for 90 days' },
      { icon: 'heart', text: 'Loved by 50,000+ sleepers' },
      { icon: 'chat', text: 'Real human support, 7 days a week' }
    ];
    return '<div class="vlr-trust">' + items.map(function (it) {
      var path = TRUST_ICONS[it.icon] || TRUST_ICONS.shield;
      return '<div class="vlr-trust__item">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + path + '</svg>' +
        '<span>' + it.text + '</span>' +
      '</div>';
    }).join('') + '</div>';
  }

  /* ---------- assurance row (3 icons under payment marks) ---------- */
  function assuranceHTML() {
    var items = [
      { p: '<path d="M12 20s-7-4.6-9.2-9C1.3 8 3 5 6 5c2 0 3 1.2 4 2.5C11 6.2 12 5 14 5c3 0 4.7 3 3.2 6-2.2 4.4-9.2 9-9.2 9z"/>', t: '50K+ Happy Customers' },
      { p: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 6 6v1"/>', t: 'Hassle-Free Returns' },
      { p: '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>', t: 'Secure Payment' }
    ];
    return '<div class="vlr-assure">' + items.map(function (it) {
      return '<div class="vlr-assure__item">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + it.p + '</svg>' +
        '<span>' + it.t + '</span>' +
      '</div>';
    }).join('') + '</div>';
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = qs('#vomToast'); if (!t) return;
    qs('#vomToastMsg').textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__vtt);
    window.__vtt = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  function setCounts(n) {
    qsa('[data-bag-count]').forEach(function (e) { e.textContent = n; });
    var dc = qs('#cartDrawerCount');
    if (dc) dc.textContent = n ? n + (n === 1 ? ' piece' : ' pieces') : '';
    /* also update Impulse cart bubble */
    var bubble = qs('.cart-link__bubble');
    if (bubble) {
      if (n > 0) bubble.classList.add('cart-link__bubble--visible');
      else bubble.classList.remove('cart-link__bubble--visible');
    }
  }

  function drawerLine(item) {
    var img = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || '');
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var compareAt = item.original_price > item.final_price ? '<s>' + money(item.original_price) + '</s> ' : '';
    return '<div class="cdl" data-key="' + item.key + '">' +
      '<a href="' + item.url + '"><img class="cdl__img" src="' + img + '" alt="' + item.product_title + '" /></a>' +
      '<div class="cdl__main">' +
        '<div class="cdl__top"><div class="cdl__name">' + item.product_title + '</div>' +
        '<button class="cdl__trash" data-cd-remove="' + item.key + '" aria-label="Remove"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14"/></svg></button></div>' +
        (variant ? '<div class="cdl__meta">' + variant + '</div>' : '') +
        '<div class="cdl__price">' + compareAt + money(item.final_price) + '</div>' +
        '<div class="cdl__ctrls">' +
          '<div class="qty"><button data-cd-qty="' + item.key + '" data-delta="-1" aria-label="Decrease">\u2212</button><span>' + item.quantity + '</span><button data-cd-qty="' + item.key + '" data-delta="1" aria-label="Increase">+</button></div>' +
        '</div>' +
      '</div></div>';
  }

  function renderDrawer(cart) {
    var d = qs('#cartDrawer'); if (!d) return;
    setCounts(cart.item_count);
    var body = qs('#cartDrawerBody'), foot = qs('#cartDrawerFoot');
    if (!cart.item_count) {
      body.innerHTML = '<div class="cartdrawer__empty"><p>Your bag is empty.</p><a href="' + (CFG.shopUrl || '/collections/all') + '" class="cartdrawer__shopbtn">Shop the sale \u2192</a></div>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = rewardBarHTML(cart) + '<div class="cartdrawer__items">' + cart.items.map(drawerLine).join('') + '</div>' +
      '<div class="upsell" id="drawerUpsell"></div>';
    var payTpl = qs('#cartPayMarks');
    var payHTML = payTpl ? payTpl.innerHTML : '';
    /* Bundle savings = pre-discount total minus final total.
       Only shown when a real cart discount is applied (0 otherwise). */
    var origTotal = (typeof cart.original_total_price === 'number') ? cart.original_total_price : cart.total_price;
    var savings = origTotal - cart.total_price;
    var savingsRow = savings > 0
      ? '<div class="cdr savings"><span>Your bundle savings</span><b>-' + money(savings) + '</b></div>'
      : '';
    var totalValue = savings > 0
      ? '<s class="cdr__was">' + money(origTotal) + '</s> ' + money(cart.total_price)
      : money(cart.total_price);
    foot.innerHTML =
      '<div class="cartdrawer__rows">' +
        savingsRow +
        '<div class="cdr total"><span>Total</span><b>' + totalValue + '</b></div>' +
      '</div>' +
      '<a href="/checkout" class="cartdrawer__checkout"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Secure checkout</a>' +
      payHTML +
      assuranceHTML();
    loadUpsell('#drawerUpsell', cart);
    /* fetch compare-at prices */
    var handles = [];
    cart.items.forEach(function(it){ if(handles.indexOf(it.handle)===-1) handles.push(it.handle); });
    Promise.all(handles.map(function(h){ return fetchJSON('/products/'+h+'.js'); }))
      .then(function(products){
        var capMap={};
        products.forEach(function(pr){ pr.variants.forEach(function(v){ capMap[v.id]=v.compare_at_price; }); });
        cart.items.forEach(function(it){
          var cap=capMap[it.variant_id];
          if(cap && cap>it.final_price){
            var el=qs('.cdl[data-key="'+it.key+'"] .cdl__price');
            if(el) el.innerHTML='<s>'+money(cap)+'</s> '+money(it.final_price);
          }
        });
      });
  }

  function refreshCart(open) {
    return fetchJSON('/cart.js').then(function (cart) {
      renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('vomaire:cart', { detail: cart }));
      if (open) openCart();
      return cart;
    });
  }
  function openCart() { var d = qs('#cartDrawer'); if (!d) return; document.body.style.overflow = 'hidden'; requestAnimationFrame(function () { d.classList.add('open'); }); }
  function closeCart() { var d = qs('#cartDrawer'); if (d) d.classList.remove('open'); document.body.style.overflow = ''; }

  /* ---------- ANALYTICS-SAFE ADD TO CART ----------------------------------
     Alle add-to-cart acties in het thema lopen via deze ene functie.

     Waarom zo:
       1. Route exact als Dawn: routes.cart_add_url ZONDER .js suffix.
          Dat is de referentie-implementatie die Shopify zelf garandeert.
       2. Transport wordt op runtime gekozen. Shopify's web-pixels-manager
          onderschept add-to-cart door fetch en/of XMLHttpRequest te patchen.
          Welke van de twee gepatcht is verschilt per winkel/versie, dus we
          detecteren het in plaats van te gokken.
       3. Dawn-headers: X-Requested-With + Accept, GEEN handmatige
          Content-Type (FormData zet die zelf, incl. boundary).

     ----------------------------------------------------------------------- */

  /* Dawn gebruikt routes.cart_add_url zonder .js — die volgen we exact. */
  function cartAddUrl() {
    var r = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    return r.replace(/\.js$/, '');
  }

  /* Welk transport wordt door Shopify onderschept? */
  function sendViaFetch(url, formData) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function sendViaXhr(url, formData) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.setRequestHeader('Accept', 'application/javascript');
      xhr.onload = function () {
        var data = null;
        try { data = JSON.parse(xhr.responseText); } catch (err) { data = null; }
        if (xhr.status >= 200 && xhr.status < 300) resolve(data);
        else reject(data || new Error('Add to cart mislukt (' + xhr.status + ')'));
      };
      xhr.onerror = function () { reject(new Error('Netwerkfout')); };
      xhr.send(formData);
    });
  }

  function postCartAdd(formData, bron) {
    /* VASTGEZET op fetch. Dit is exact wat Dawn doet en wat Shopify
       garandeert te onderscheppen. Geen runtime-detectie meer: die kon
       de verkeerde kiezen en was daarmee een onbekende variabele. */
    return sendViaFetch(cartAddUrl(), formData).then(function (data) {
      announceAdd(data);
      return data;
    });
  }

  /* Extra signaal voor pixels van derden (Meta/wetracked/GA4).
     Let op: dit vult Shopify's eigen rapportage NIET aan — dat doet het
     verzoek hierboven. Dit is puur een haakje voor third-party tracking. */
  function announceAdd(data) {
    try {
      document.dispatchEvent(new CustomEvent('velrest:added', { detail: data }));
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('velrest_add_to_cart', {
          items: (data && data.items) ? data.items : (data ? [data] : [])
        });
      }
    } catch (err) { /* tracking mag de add-to-cart nooit laten falen */ }
  }

  function addToCart(variantId, qty, opts) {
    opts = opts || {};
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty || 1);
    return postCartAdd(fd, opts.bron || 'quick-add')
      .then(function () { return refreshCart(!opts.silent); });
  }

  function changeLine(key, qty) {
    return fetchJSON('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (cart) { renderDrawer(cart); document.dispatchEvent(new CustomEvent('vomaire:cart', { detail: cart })); return cart; });
  }

  /* ---------- upsell ---------- */
  function miniCard(p) {
    var v = p.variants[0];
    var compare = (v.compare_at_price && v.compare_at_price > v.price) ? '<s>' + money(v.compare_at_price) + '</s>' : '';
    var imgSrc = p.featured_image || (p.images && p.images[0]) || '';
    /* ensure Shopify CDN image is sized correctly */
    if (imgSrc && imgSrc.indexOf('cdn.shopify.com') > -1) {
      imgSrc = imgSrc.replace(/(\.[a-z]+)\?/, '_300x$1?');
      if (imgSrc.indexOf('?') === -1 && imgSrc.indexOf('_300x') === -1) {
        imgSrc = imgSrc.replace(/(\.[a-z]+)$/, '_300x$1');
      }
    }
    return '<div class="umini">' +
      '<a href="' + p.url + '"><img class="umini__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy" /></a>' +
      '<a class="umini__name" href="' + p.url + '">' + p.title + '</a>' +
      '<div class="umini__price">' + (compare ? compare + ' ' : '') + money(v.price) + '</div>' +
      '<button class="umini__add" data-add-variant="' + v.id + '">Add to cart</button>' +
    '</div>';
  }
  function loadUpsell(sel, cart) {
    var host = qs(sel); if (!host) return;
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = 1; });

    /* Normalize a /products.json product into the shape miniCard expects
       (prices in cents, url + featured_image strings). */
    function normalize(p) {
      var v0 = (p.variants || [])[0]; if (!v0) return null;
      function cents(x) { var n = parseFloat(x); return isNaN(n) ? 0 : Math.round(n * 100); }
      var img = (p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : '';
      return {
        id: p.id,
        title: p.title,
        url: '/products/' + p.handle,
        featured_image: img,
        images: [img],
        available: (p.variants || []).some(function (v) { return v.available; }),
        variants: [{
          id: v0.id,
          price: cents(v0.price),
          compare_at_price: v0.compare_at_price ? cents(v0.compare_at_price) : null
        }]
      };
    }

    function render(prods) {
      prods = prods.filter(function (p) { return p && p.available && !inCart[p.id]; });
      if (!prods.length) { host.innerHTML = ''; return; }
      host.innerHTML =
        '<div class="cartups cartups--addons">' +
          '<div class="cartups__head"><span class="cartups__title">Complete your order</span><span class="cartups__pill">Most popular add-ons</span></div>' +
          '<div class="upsell__track">' + prods.map(miniCard).join('') + '</div>' +
        '</div>';
    }

    /* Show ALL store products in one horizontally-scrollable row. */
    fetch('/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).map(normalize);
        if (prods.filter(Boolean).length) { render(prods); return; }
        throw new Error('empty');
      })
      .catch(function () {
        /* Fallback: related recommendations (already in the right shape) */
        var pid = cart && cart.items && cart.items[0] ? cart.items[0].product_id : null;
        if (!pid) { host.innerHTML = ''; return; }
        fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) { render(data.products || []); })
          .catch(function () { host.innerHTML = ''; });
      });
  }

  /* ---------- delegated events for cart drawer ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-open-cart]'))) { e.preventDefault(); refreshCart(true); }
    else if ((t = e.target.closest('[data-close-cart]'))) { e.preventDefault(); closeCart(); }
    else if ((t = e.target.closest('[data-checkout]'))) { e.preventDefault(); window.location.href = '/checkout'; }
    else if ((t = e.target.closest('[data-add-variant]'))) { e.preventDefault(); addToCart(t.getAttribute('data-add-variant'), 1); }
    else if ((t = e.target.closest('[data-cd-qty]'))) {
      var line = t.closest('.cdl'); var span = qs('.qty span', line);
      var cur = parseInt(span.textContent, 10); var d = parseInt(t.getAttribute('data-delta'), 10);
      changeLine(t.getAttribute('data-cd-qty'), Math.max(0, cur + d));
    }
    else if ((t = e.target.closest('[data-cd-remove]'))) { changeLine(t.getAttribute('data-cd-remove'), 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- intercept ALL cart links ---------- */
  document.addEventListener('click', function (e) {
    var t;
    /* SECURE CHECKOUT link — let it navigate to /checkout */
    if ((t = e.target.closest('.cartdrawer__checkout'))) {
      e.stopPropagation();
      window.location.href = '/checkout';
      return;
    }
    /* Cart icon (.js-drawer-open-cart) */
    if ((t = e.target.closest('.js-drawer-open-cart'))) {
      e.preventDefault();
      e.stopPropagation();
      refreshCart(true);
      return;
    }
    /* Any <a> going to /cart */
    if ((t = e.target.closest('a'))) {
      var href = t.getAttribute('href') || '';
      if (href === '/cart' || href.match(/\/cart(\?|$)/)) {
        e.preventDefault();
        e.stopPropagation();
        refreshCart(true);
        return;
      }
    }
  }, true); /* capture phase — runs before Impulse */

  /* ---------- after Impulse adds product: open Vomaire drawer ---------- */
  document.addEventListener('ajaxProduct:added', function () {
    /* Close Impulse drawer if it opened */
    var impulseDrawer = document.getElementById('CartDrawer');
    if (impulseDrawer) impulseDrawer.classList.remove('drawer--is-open');
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-cart');
    /* Open Vomaire drawer */
    refreshCart(true);
  });

  /* ---------- Own Add-to-cart submit: always AJAX-add and open the drawer ----------
     Runs in capture phase and stops the Impulse handler so there's no double add
     and no navigation to the /cart page. Works even if Impulse's ajax add is off. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[name="add"], [data-add-to-cart]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    postCartAdd(new FormData(form), 'product-form')
      .then(function () { return refreshCart(true); })
      .catch(function () {})
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }, true);


  /* ---------- /cart page redirect ---------- */
  function redirectCartPage() {
    if (window.location.pathname === '/cart') {
      window.location.replace('/collections/all');
    }
  }

  /* ---------- expose ---------- */
  window.Vomaire = {
    money: money, addToCart: addToCart, postCartAdd: postCartAdd, refreshCart: refreshCart,
    openCart: openCart, closeCart: closeCart,
    discountFor: discountFor, bundleProgressHTML: bundleProgressHTML, toast: toast, miniCard: miniCard,
    loadUpsell: loadUpsell, fetchJSON: fetchJSON, BUNDLE: BUNDLE
  };

  /* ---------- init ---------- */
  function init() {
    redirectCartPage();
    refreshCart(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
